export interface IQuoteTotalsSummary {
  totalInvoice: number
  totalInvoicePastDue: number
}

export class QuoteTotalsSummary {
  public totalInvoice: number
  public totalInvoicePastDue: number
}
